export default {
  active_orders: {
    title: 'Ordini attivi',
  },
  order_history: {
    title: 'Storico ordini',
  },
  menu: {
    title: 'Menu',
  },
  printer_settings: {
    title: 'Impostazioni stampante',
  },
  order_control: {
    title: 'Controllo ordini',
  },
  busy_mode: {
    title_zero: 'Modalità occupato',
    title_other: 'Modalità occupato (+{{time}} min)',
  },
  volume: {
    title: 'Volume',
  },
  switch_language: {
    title: 'Cambia lingua ({{language}})',
  },
  logout: {
    title: 'Esci',
    description: 'Sei sicuro di voler uscire?',
    buttons: {
      confirm: 'Sì',
      cancel: 'Annulla',
    },
  },
  test_restaurant: {
    label: 'Test',
    tooltip: 'Ristorante di prova: i suoi ordini sono di test e non viene mai fatturato.',
  },
};
